import { HighlightedBox } from '@components/common/HighlightedBox';
import React from 'react';
import * as S from './ChallengeInfo.styled';
export const ChallengeInfo = () => {
    return (React.createElement(S.Container, null,
        React.createElement(HighlightedBox, { text: "Exclusive offer: $50 of free sample credit", size: "small" }),
        React.createElement("div", null, "Order samples today and we'll refund you $50 if you can sell 6 products within 60 days!\u00A0")));
};
